<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'app'
  }
</script>

<style lang="scss">
  @import "../node_modules/normalize.css/normalize.css";
  @import "../node_modules/hotcss/src/px2rem.scss";
  @import "./assets/style/settings.scss";
  @import "./assets/style/flex.scss";

  html {
    font-size: 16px;
    font-family: メイリオ, Meiryo,'Hiragino Kaku Gothic ProN','ヒラギノ角ゴ ProN W3','ＭＳ Ｐゴシック','MS PGothic',sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: $color-bg-white;
  }

  body {
    @import "./assets/style/settings.scss";
    background: $color-bg-white;
  }

  @media screen and (min-device-width: 720px) {
    html {
      background: $color-bg-white;
    }
    body {
      max-width: 720px;
      margin: 0 auto;
      min-height: 1000px;
      border-left: 1px solid #e4e4e4;
      border-right: 1px solid #e4e4e4;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue